export const forwardingUserTypeDict = {
  consignee: "수입",
  forwarder: "물류",
  customs: "관세",
  "": "",
};
